export class ComboMetaAcao {
    id: number;
    descricao: string;
}